import React from "react";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function BlankDropdown({
  width,
  label,
  selected,
  style,
  className,
}) {
  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{ width, ...style }}
    >
      <label className="dropdown-CB-label">{label}</label>
      <div
        className="dropdown-btn"
        style={{ cursor: "default", opacity: 0.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        <span style={{ fontWeight: "500", color: "#000", opacity: 1 }}>
          {selected || ""}
        </span>
        <img
          src={DropDownIcon}
          alt="dropdown-icon"
          style={{ pointerEvents: "none", opacity: 0.5 }}
        />
      </div>
    </div>
  );
}
